import { useTranslation } from 'next-i18next'

import { useAppSelector } from '~/redux/hooks'

import NicknameOverlay from '../components/ProfileCards/NicknameOverlay'
import ProductCardsContainer from '../components/ProductCards/ProductCardsContainer'
import ProductCardTimeFilter from '../components/ProductCards/ProductCardTimeFilter'
import ProfileCard from '../components/ProfileCards/ProfileCard'
import { selectShowNicknameOverlay } from '../redux/statistics.slice'

export default function StatisticsPage(): React.ReactElement {
  const { t } = useTranslation('dashboard')

  const showNicknameOverlay = useAppSelector(selectShowNicknameOverlay)

  return (
    <>
      {showNicknameOverlay && <NicknameOverlay />}
      <h1 className="text-h3 font-bold text-white text-center my-8">{t('myStats')}</h1>
      <div className="flex flex-col lg:flex-row px-4 lg:mx-auto mb-16 w-full max-w-339 gap-3">
        <div className="relative lg:mt-4 mx-auto w-full max-w-100 lg:max-w-92.5">
          <ProfileCard />
        </div>

        <div className="mt-4 lg:mt-0 mx-auto lg:mx-0 w-full max-w-100 lg:max-w-full xl:max-w-186.5">
          <ProductCardTimeFilter />
          <ProductCardsContainer />
        </div>
      </div>
    </>
  )
}
